<template>
  <app-modal
    :modal-id="modalId"
    :title="title"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
    modal-size="extra-large"
    modal-alignment="top"
  >
    <template slot="header">
      <h5 class="modal-title">{{ title }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>

    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl
            ? `/masterData/manage-signatures/${inputs.id}`
            : `/masterData/manage-signatures`
        "
      >
        <div class="col-sm">
          <div class="card">
            <div class="card-header d-sm-flex justify-content-sm-left">
              <div>
                <h5>Formulario</h5>
              </div>
            </div>
            <div class="card-body">
              <div class="col-md-12">
                <div class="form-group">
                  <label class="mb-0">Activo</label>
                  <app-input
                    type="radio-buttons"
                    v-model="inputs.is_active"
                    :list="isActive"
                  />
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <label class="mb-1">
                    Nombre <span class="color-req">*</span>
                  </label>
                  <app-input
                    type="text"
                    v-model="inputs.name"
                    placeholder="Ingresar texto.."
                    :required="true"
                  />
                  <small v-if="errors.name" class="color-txt">Este campo es obligatorio</small>
                </div>
              </div>

              <div class="col-12">
                <div class="form-group">
                  <label class="mb-1">
                    Código <span class="color-req">*</span>
                  </label>
                  <app-input
                    type="text"
                    v-model="inputs.code"
                    placeholder="Ingresar texto.."
                    @input="toUpperCase"
                    :disabled="disablecode"
                  />
                  <small v-if="errors.code" class="color-txt">Este campo es obligatorio</small>
                </div>
              </div>

              <div class="col-12">
                <div class="form-group">
                  <label class="mb-1">
                    Firmado <span class="color-req">*</span>
                  </label>
                  <quill-editor
                    v-model="inputs.signed1"
                    :options="editorOption"
                  />
                  <small v-if="errors.signed1" class="color-txt">Este campo es obligatorio</small>
                </div>
              </div>

              <dynamic-signature
                titleva="Firmas"
                self="profiles"
                :model="signatures"
                :auxsig="auxsig"
              />
            </div>
          </div>
        </div>
      </form>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        Cerrar
      </button>
      <button type="button" class="btn btn-primary" @click="submit">
        Guardar
      </button>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";
import { quillEditor } from "vue-quill-editor";
import DynamicSignature from "./DynamicSignature";

export default {
  mixins: [FormMixin, ModalMixin],
  components: { quillEditor, DynamicSignature },
  props: {
    tableId: String,
    modalTitle: String,
    editModalTitle: String,
    disablecode: Boolean,
  },
  data() {
    return {
      preloader: false,
      loaded: false,
      disable: false,
      inputs: {
        is_active: 1,
      },
      signatures: {},
      auxsig: [],
      errors: {
        name: null,
        code: null,
        signed1: null,
      },
      modalId: "modal-add-edit",
      isActive: [
        {
          id: 1,
          value: "SI",
        },
        {
          id: 0,
          value: "NO",
        },
      ],
      editorOption: {
        placeholder: "Inserte el texto aquí..",
        modules: {
          toolbar: [
            [{ size: ["small", false, "large", "huge"] }],
            [
              "bold",
              "italic",
              "underline",
              "strike",
              { color: [] },
              { background: [] },
            ],
            [{ align: [] }],
            [
              { list: "ordered" },
              { list: "bullet" },
              { indent: "-1" },
              { indent: "+1" },
            ],
            ["clean"],
          ],
        },
      },
    };
  },
  computed: {
    title() {
      return this.selectedUrl ? this.editModalTitle : this.modalTitle;
    },
  },
  created() {
    if (this.selectedUrl) {
      this.preloader = true;
    } else {
      this.loaded = true;
    }
  },
  methods: {
    submit() {
      
      this.errors.name = !this.inputs.name || this.inputs.name.trim() === '';
      this.errors.code = !this.inputs.code || this.inputs.code.trim() === '';
      this.errors.signed1 = !this.inputs.signed1 || this.inputs.signed1.trim() === '';

      if (this.errors.name || this.errors.code || this.errors.signed1) {
        return;
      }
        
      var request = {};
      request["color"] = "#1CA085";
      request["inputs"] = this.inputs;
      request["signatures"] = this.signatures;
      this.save(request);
    },
    afterSuccess(response) {
      if (this.selectedUrl != "") {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      this.inputs = {
        ...response.data,
      };
      if (response.data.additional_sig == 1) {
        this.auxsig.push(response.data.signed2);
      } else if (response.data.additional_sig == 2) {
        this.auxsig.push(response.data.signed2);
        this.auxsig.push(response.data.signed3);
      }
      this.preloader = false;
      this.loaded = true;
    },

    afterFinalResponse() {
      this.closeModal();
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },
    toUpperCase(event) {
      // Convierte el valor ingresado a mayúsculas y actualiza el modelo
      this.inputs.code = event.toUpperCase();
    },
  },
};
</script>
<style>
.color-req {
  color: red;
}

.color-txt {
  color: #F96868;
}

.space {
  margin-top: 100px;
}
</style>
